import { render, staticRenderFns } from "./CategoryMultiDropdown.vue?vue&type=template&id=41079f52&"
import script from "./CategoryMultiDropdown.vue?vue&type=script&lang=js&"
export * from "./CategoryMultiDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports